<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-data" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-data" width="800px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("data.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("data.used-places") }}</h5>

          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ sourceNames(i) }}
                </td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <h2>{{ $t("data.organization-datas") }}</h2>

    <nav class="breadcrumb">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" href="/department">
        {{ $t("department.text") }}
      </a>

      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("data.text") }}
      </a>
    </nav>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('data.text')" tag="span" :request="request" />
        </th>
        <th scope="col" style="width:300px">{{ $t("data-category.text") }}</th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>

        <th>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('data-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            @changed="onCategorySelect"
          />
        </th>

        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id" v-b-tooltip.hover>
        <div class="card text-center p-2" v-bind:class="{ 'bg-success': item.completed }">
          <div @click="fetchInfo(item)" v-b-toggle="'sidebar-info-data'">
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.name | translate }}
              </h6>
              <span v-if="item.category" class="mb-0 text-muted">
                {{ item.category.name | translate }}
              </span>
              <span v-else class="text-light-gray" v-b-tooltip.hover :title="$t('data.no-category')">
                {{ $t("data.no-category") }}
              </span>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasUpdatePermission" class="flex-fill">
                <a @click="edit(item)" @click.stop="fetchInfo(item)" v-b-toggle="'sidebar-edit-organization-department'" v-b-tooltip.hover :title="$t('common.edit')">
                  <i class="bx bx-pencil text-primary"></i>
                </a>
              </div>

              <div v-if="hasRemovePermission" class="flex-fill">
                <a href="javascript:;void(0);" @click="deleteById(item)" @click.stop="fetchInfo(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
              <!-- <div class="flex-fill mt-1" v-b-tooltip.hover :title="$t('common.completed')">
                <b-form-checkbox switch size="sm" v-model="item.completed" @input="markAsComplete(item)" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("data.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import { conflictMessage } from "@/helpers/conflict-message"; // TKP-215
import { sourceNamesOf, withoutInfoRow } from "@/modules/process-data/info-row";
import Form from "./organization-data-form";

export default {
  components: { Form },
  data() {
    return {
      selectedItam: undefined,
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationData/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationData/pagination"];
    },

    isLoading() {
      return this.$store.getters["organizationData/isLoading"];
    },
    infoItem() {
      return this.$store.getters["organizationData/infoItem"];
    },
    info() {
      return this.$store.getters["organizationData/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationData/isInfoLoading"];
    },
    hasViewPermission() {
      return true;
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    sourceNames(row) {
      return sourceNamesOf(row, this.$options.filters.translate);
    },
    async paginate() {
      await this.$store.dispatch("organizationData/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationData/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: conflictMessage(error) || "'" + this.$options.filters.translate(item.name) + "' Silinemedi" }); // TKP-215: kullanımda — sunucunun gerekçesi
      }
    },
    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        // TKP-27 / 6.4c-1: satır düğüm (süreç×veri) — veri süreçten tüm kaynaklarıyla çıkar
        await this.$store.dispatch("organizationProcessData/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        // Düğüm silme kuyruktan geçer (TKP-25); hemen yeniden okumak satırı bir süre geri getirir — yerelde düşülür.
        this.$store.commit("organizationData/info", withoutInfoRow(this.info, item.rel_id));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    edit(item) {
      this.$store.commit("organizationData/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationData/fetchInfo", { item, pagination: this.infoRequest });
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDataCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },

    onCategorySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          category: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationData/resetForm");
    },
  },
};
</script>
